import { render, staticRenderFns } from "./TrainCxr.vue?vue&type=template&id=19b16fb8&scoped=true&"
import script from "./TrainCxr.vue?vue&type=script&lang=js&"
export * from "./TrainCxr.vue?vue&type=script&lang=js&"
import style0 from "./TrainCxr.vue?vue&type=style&index=0&id=19b16fb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b16fb8",
  null
  
)

export default component.exports